import React from 'react';
import { ClockIcon, HeartIcon } from '@radix-ui/react-icons';
import { NotificationItem, NotificationModule } from '../../../types/notification';

const MODULE_ICON: Record<
  NotificationModule,
  { className: string; icon: 'heart' | 'clock' }
> = {
  Matches: { className: 'notification-card__icon--match', icon: 'heart' },
  Tasks: { className: 'notification-card__icon--task', icon: 'clock' },
};

const NotificationIcon: React.FC<{ module: NotificationModule }> = ({ module }) => {
  const config = MODULE_ICON[module];

  if (config.icon === 'heart') {
    return <HeartIcon aria-hidden="true" />;
  }

  return <ClockIcon aria-hidden="true" />;
};

interface NotificationCardProps {
  notification: NotificationItem;
  onClick?: (notification: NotificationItem) => void;
}

export const NotificationCard: React.FC<NotificationCardProps> = ({
  notification,
  onClick,
}) => {
  const tone = MODULE_ICON[notification.module];
  const isUnread = notification.isNew;

  return (
    <article
      className={`notification-card ${isUnread ? 'notification-card--unread' : ''}`}
      onClick={() => onClick?.(notification)}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick(notification);
              }
            }
          : undefined
      }
    >
      <div className={`notification-card__icon ${tone.className}`}>
        <NotificationIcon module={notification.module} />
        {isUnread && <span className="notification-card__unread-dot" aria-label="Unread" />}
      </div>

      <div className="notification-card__body">
        <div className="notification-card__title-row">
          <h3>{notification.title}</h3>
        </div>
        <p>{notification.subtitle}</p>
        <footer>
          {notification.dateStr} &bull; {notification.module}
        </footer>
      </div>
    </article>
  );
};
